import React, { useEffect, useState } from "react";
import {
    FaUserClock,
    FaUserCheck,
    FaUserPlus,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";

function SummaryCards({ summaryData, onClick }) {
    const [selectedId, setSelectedId] = useState(null);
    const complaintData = [
        {
            complaint: summaryData?.new || 200,
            label: "Total Staffs",
            color: "text-black",
            icon: <FaUserClock className="text-yellow-400" />,
            filter: 'P',
        },
        {
            complaint: summaryData?.closed || 180,
            label: "Total Present",
            color: "text-black",
            icon: <FaUserCheck className="text-green-400" />,
            filter: 'R',
        },
        {
            complaint: summaryData?.assigned || 20,
            label: "Total Absent",
            color: "text-black",
            icon: <FaUserPlus className="text-blue-400" />,
            filter: 'A',
        },
    ];

    return (
        <Wrapper>

            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {complaintData.map((item, index) => (
                    <Card selectedId={selectedId} index={index} key={index} onClick={() => {
                        setSelectedId(index);
                        onClick(item.filter);
                    }
                    }>
                        <div className="h-16">
                            <Value color={item.color}>{item.complaint}</Value>
                            <Label>
                                {item.label}
                                <MdOutlineChevronRight className="text-gray-300" size={24} />
                            </Label>
                        </div>
                    </Card>
                    // <Card key={index} onClick={() => onClick(item.filter)}>
                    //     <div >
                    //         <span className={`text-lg font-bold ${item.color}`}>
                    //             {item.complaint}
                    //         </span>
                    //         <Label>
                    //             {item.label}
                    //             {item.icon}
                    //         </Label>
                    //     </div>
                    // </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1 pl-0.5`;
const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedId, index }) => selectedId === index ? "shadow-sm shadow-primary-color" : ""}`;
const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
const Value = tw.p`
  text-xl sm:text-2xl font-bold relative 
  ${({ color }) =>
        color}
`;

export default SummaryCards;

